import { produce } from 'immer';
import _ from 'lodash';

import { LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE } from '../types/loanEditorCustomForms.types';

const initialState = {
  forms: [],
  isLoading: false,
};

const loanEditorCustomFormsReducer = produce((draft, { type, payload }) => {
  switch (type) {
    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.SET_FORMS:
      draft.forms = _.isArray(payload) ? payload : [];
      break;

    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.SET_LOADING:
      draft.isLoading = !!payload;
      break;

    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.UPSERT_FORM:

    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.SET_FORM: {
      if (_.isNil(payload?.id)) {
        break;
      }

      const index = draft.forms.findIndex(form => form.id === payload.id);

      if (index === -1) {
        draft.forms.push(payload);
        break;
      }

      draft.forms[index] = { ...draft.forms[index], ...payload };
      break;
    }

    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.REMOVE_FORM:
      if (!_.isNil(payload)) {
        draft.forms = draft.forms.filter(form => form.id !== payload);
      }

      break;

    case LOAN_EDITOR_CUSTOM_FORMS_ACTION_TYPE.RESET:
      return initialState;

    default:
      return draft;
  }
}, initialState);

export default loanEditorCustomFormsReducer;
